class VoucherTypeController extends AbstractEntityEditController
	@register()
	@inject '$filter',
		'API_ENDPOINT'
		'CredentialsManager'
		'ConfigurationService'
		'Guid'
		'priceRegions'
		'ProductRepository'
		'ProductCategoryRepository'
		'MessageTerminal'
		'ToastService'
		'vatRates'
		'voucherType'
		'VoucherTypeRepository'
		'DEFAULT_PRODUCT_DATA_LABEL'
		'BACKEND_PRODUCT_ENTITY_TYPE'
		'parseBool'
		'ProductService'

	initialize: ->
		@priceRegions = angular.copy @priceRegions
		@mainCrud.entityType = 'wbo.voucher.type'
		@mainCrud.entityTitle = 'wbo.title.voucher.list'

		@allowImageEdit = @ConfigurationService.getValue('Backoffice.Setting.Cdn.Url') == null
		@selectedPriceRegion = null
		@results = []
		@qrCodesQuantity = 1

		if @voucherType.product
			@voucherType.product.active = @parseBool(@voucherType.product.active)

		if @voucherType.id?
			@mainCrud.entityTitle = @voucherType.name
			@mainCrud.isNewEntity = false

			@initializeVoucherType()

			if !@voucherType.product?
				@mainCrud.showSave = false
				@productError = true

				@addErrorMessage @voucherType.product_id, @translate('wbo.toast.product.deleted')

				return

		else
			@voucherType =
				product:
					active: true,
					offline_product: "1",
					attributes: [],
					name: null
					product_data: []
				eligible_sets: []

		if _.isEmpty(@voucherType.eligible_sets)
			@addEmptyEligibleSet()

		@tabs = [
			{
				title: 'wbo.vouchertype.details'
				selector: '#tab-voucher-details'
			}
			{
				title: 'wbo.tab.pricing'
				selector: '#tab-voucher-pricing'
			}
			{
				title: 'wbo.vouchertype.eligible_sets'
				selector: '#tab-voucher-eligible-sets'
				disabled: @voucherType.is_giftcard
			}
			{
				title: 'bounty.generate.qr.codes'
				selector: '#tab-voucher-qr-codes'
				disabled: @mainCrud.isNewEntity
				show_action_buttons: false
			}
			{
				title: 'wbo.vouchertype.issue.giftcard'
				selector: '#tab-voucher-issue-giftcard'
				disabled: @mainCrud.isNewEntity ||
					@ConfigurationService.isDisabled('Backoffice.Permission.Vouchers.IssueGiftcard.Enabled') ||
					@ConfigurationService.isDisabled('Shared.Payment.MiscellaneousType.Enabled') ||
					!@voucherType.product.active
				show_action_buttons: false
			}
		]

		@MessageTerminal.on @$scope,
			@MessageTerminal.events.TAB_CHANGE,
			(tab) =>
				@mainCrud.showFormActionButtons = tab.show_action_buttons != false

		updatePriceValidity = (productData) =>
			hasAnyPrice = !_.isEmpty(productData)
			@hasAnyPrice = hasAnyPrice

			if @mainCrud.parent_form?
				@mainCrud.parent_form.$setValidity('priceRequired', hasAnyPrice)

		updatePriceValidity(@voucherType.product?.product_data)

		@$scope.$watchCollection 'vm.voucherType.product.product_data', (newValue) =>
			updatePriceValidity(newValue)

		@$scope.$watch 'mainCrud.parent_form.$dirty', (newValue) =>
			isDirty = @parseBool(newValue)

			@tabs[3].inactive = isDirty
			@tabs[4].inactive = isDirty

		@$scope.$watch 'vm.voucherType.product.name', () => @onNameChange()

	initializeVoucherType: ->
		@voucherType.expire_interval = parseInt(@voucherType.expire_interval) || null
		@voucherType.units = parseInt(@voucherType.units)

		if !parseInt(@voucherType.is_giftcard)
			for set in @voucherType.eligible_sets
				for category in set.product_categories
					category.selected = true

				for product in set.products
					product.selected = true
					product.collapse = true

					for variant in product.product_variants
						variant.selected = set.product_variants.includes(variant.id)

	selectPriceRegion: (priceRegionId) ->
		@selectedPriceRegion = _.find(@priceRegions, {id: priceRegionId})

	onNameChange: ->
		if @voucherType.product.name
			@voucherType.name = @voucherType.product.name

			if !@voucherType.id || !@voucherType.identifier
				# Trim identifier to be less than 128 chars as we add 7 more to to fit to VARCHAR(128) DB field
				suffix = '-' + @Guid.randomString(6)
				identifier = @voucherType.name
					.replace(/\W/g, '-')
					.replace(/-+/g, '-')
					.substring(0, 128 - suffix.length)
					.replace(/^\W|\W$/, '')
					.toLowerCase()
				@voucherType.identifier = identifier + suffix

	findCategories: (searchTerm) ->
		query = @ProductCategoryRepository.createQuery()
		query.criteria 'name', 'LIKE', '%' + searchTerm + '%'
		query.setPagination 0, 50

		return @ProductCategoryRepository.findByQuery(query)

	formatPrice: (value) ->
		if _.isEmpty value
			return value

		value = ("00"+value).substr(-3)

		beforeDecimal = value.substr(0, value.length - 2)
		afterDecimal = value.substr(-2)

		return beforeDecimal + "." + afterDecimal

	findCategoriesAndProducts: (search) ->
		productsQuery = @ProductRepository.createQuery()
		productsQuery.with 'product_variants', 'product_categories'

		if search.length > 0
			criteria = @ProductRepository.addSkuCriteria(productsQuery, search)
			criteria.or('name', 'LIKE', search)

		productsNotIn = []
		categoriesNotIn = []

		for set in @voucherType.eligible_sets
			if set.product_categories.length
				categoriesNotIn = categoriesNotIn.concat(set.product_categories)

			productsNotIn = productsNotIn.concat(set.products)

		productsNotIn = _.pluck(productsNotIn, 'id');
		productsQuery.criteria('id', 'NOT IN', productsNotIn.join(','))
		productsQuery.criteria('entity_type', '=', @BACKEND_PRODUCT_ENTITY_TYPE.PRODUCT)
		productsQuery.setPagination 0, @ProductRepository.pageSize

		categoryQuery = @ProductCategoryRepository.createQuery()
		categoryQuery.criteria 'name', 'LIKE', '%' + search + '%'

		categoriesNotIn = _.pluck(categoriesNotIn, 'id');
		categoryQuery.criteria 'id', 'NOT IN', categoriesNotIn.join(',')
		categoryQuery.setPagination 0, @ProductCategoryRepository.pageSize

		batch = [
			@ProductRepository.findByQuery(productsQuery)
			@ProductCategoryRepository.findByQuery(categoryQuery)
		]

		@ProductRepository
			.all(batch)
			.then (response) =>
				@results = response[0].data.concat(response[1].data)

	addEligibleSetItem: (item, set) ->
		item.selected = true

		if item.product_variants
			conflictedCategory = @getConflictingCategories(item, set)

			if conflictedCategory?
				@ToastService.add(
					@translate('wbo.voucher.type.product.conflict') + " " + conflictedCategory.name,
					'Integration',
					@translate('general.error'),
					'error',
					3000
				)
				return

			item.collapse = true

			for variant in item.product_variants
				variant.selected = true

			set.products.push(item)
		else
			set.product_categories.push(item)
		# Remove items from dropdown result
		@results = []

	###
	# Look all other sets to see if the selected product conflicts with categories in other sets.
	###
	getConflictingCategories: (product, currentSet) ->
		for productCategory in product.product_categories
			for set in @voucherType.eligible_sets
				if set == currentSet
					continue

				for setCategory in set.product_categories
					if setCategory.id == productCategory.id && setCategory.selected
						return setCategory
		return null

	canInverse: ->
		if @voucherType.eligible_sets.length == 1
			return true

		for set in @voucherType.eligible_sets
			set.inverse = 0

		return false

	addEmptyEligibleSet: ->
		@voucherType.eligible_sets.push({
			product_categories: []
			products: []
			product_variants: []
			inverse: false
		})

	removeEligibleSet: (set) ->
		@voucherType.eligible_sets = _.without(@voucherType.eligible_sets, set)

		if @voucherType.eligible_sets.length == 0
			@addEmptyEligibleSet()

		@mainCrud.parent_form.$setDirty()

	save: ->
		if @mainCrud.parent_form.$invalid
			return

		@voucherType = @getVoucherTypeForSaving()

		@VoucherTypeRepository
			.saveWithAttachment(@voucherType, @mainCrud.isNewEntity)
			.then (response) =>
				issueVoucherTabIndex = @tabs.findIndex((tab) => tab.selector == '#tab-voucher-issue-giftcard')
				@tabs[issueVoucherTabIndex].disabled = !@voucherType.product.active
				@afterSave(response)
			.catch (response) =>
				@handleErrors response

	delete: ->
		@deleteEntity(@VoucherTypeRepository, @voucherType)

	###
	#
	# @TODO: Implement models functionality that saves attributes apart from in-view fields
	#
	# Remove all not needed information:
	# - product from voucherType
	# - Delete array elements from voucherType eligible_sets products/product_variants/product_categories, having property 'selected' false
	# - Leave only ID from voucherType eligible_sets products/product_variants/product_categories
	# - Leave only ID from product product_categories
	#
	###
	getVoucherTypeForSaving: ->
		###
		# Re-assign "image" back to product as .copy does deepCopy and loses "image instanceof File" therefore product image will be lost
		# @link https://github.com/angular/angular.js/issues/14352
		###
		image = @voucherType.product.image
		voucherType = angular.copy(@voucherType)
		delete voucherType.product.image

		if image?
			voucherType.image = image

		voucherType.product.product_categories = _.pluck(voucherType.product.product_categories, 'id')

		if !@parseBool(voucherType.is_giftcard)
			for set in voucherType.eligible_sets
				set.product_variants = []
				products = []

				for product in set.products
					if product.selected != true
						continue

					products.push product.id

					if !_.isEmpty product.product_variants
						set.product_variants = _.union(set.product_variants, @getIdsOfSelected product.product_variants)

				set.products = products
				set.product_categories = @getIdsOfSelected set.product_categories
		else
			voucherType.eligible_sets = []
			voucherType.includes_addons = '1'

			if voucherType.product.product_data[0].variable_price
				voucherType.units = 1
			else
				voucherType.units = voucherType.product.product_data[0].retail_price || 1

		voucherType.product.ENTITY_TYPE = @BACKEND_PRODUCT_ENTITY_TYPE.VOUCHER
		# Only allow to buy separate vouchers, not multi-quantity
		voucherType.product.max_quantity_per_line_item = 1

		return voucherType

	getIdsOfSelected: (items) ->
		_.chain items
			.filter (item) ->
				item.selected == true
			.pluck 'id'
			.value()

	generateQrCodes: (quantity) ->
		quantity = parseInt(quantity)

		if quantity > 0
			voucherType = @voucherType
			url = @API_ENDPOINT +
				"/generate_qr_codes?xlsx_name=" + voucherType.name +
				"&identifier=" + voucherType.identifier +
				"&quantity=" + quantity +
				"&access_token=" + @CredentialsManager.getResourceToken()
			window.open(url, '_blank')
		return
